<template>

    <div class="app-checkbox">
        <label>
            <span class="control">
                <input type="checkbox"
                       v-model="newValue"
                       @change="onInput">

                <span class="graphics" v-html="$icon('check')"></span>
            </span>

            <span class="label" v-html="label" v-if="label"></span>
        </label>

        <p class="message" v-if="message">{{ message }}</p>
        <p class="error" v-if="error">{{ error }}</p>
    </div>

</template>

<script>

    export default {
        emits: ['update:modelValue', 'change'],

        props: {
            modelValue: [Boolean],
            label: String,
            placeholder: String,
            message: String,
            error: String
        },

        data() {
            return {
                newValue: this.modelValue,
                focused: false
            }
        },

        watch: {
            value() {
                this.newValue = this.modelValue;
            }
        },

        methods: {

            onInput() {
                this.$emit('update:modelValue', this.newValue);
                this.$emit('change', this.newValue);
            }

        },

        computed: {
            filled() {
                return this.newValue || this.focused
            }

        }

    }

</script>

<style lang="scss" scoped>

.control {

    .graphics {
        ::v-deep svg {
            display: block;
            opacity: 0;
            flex-grow: 1;
        }
    }

    input:checked + .graphics {
        ::v-deep svg {
            opacity: 1;
        }
    }

}

</style>
